import { useMemo } from 'react'

import { ImageSlider } from '../image-slider/image-slider'
import { LoadingImage } from '../loading-image/loading-image'
import { CardImageContainer } from './card'

type CardImageProps = {
  images: { url: string; alt?: string }[]
  title: string
  disableSlider?: boolean
  reduceTransitions?: boolean
  aspectRatio: 'video' | 'square'
  fallbackImageSrc: string
  className?: string
}

export function CardImage({
  images,
  title,
  disableSlider = false,
  reduceTransitions = false,
  aspectRatio,
  fallbackImageSrc,
  className,
}: CardImageProps) {
  const formattedImages = useMemo(() => {
    const fallbackImage = {
      url: fallbackImageSrc,
      alt: title,
      sizes: '640px',
    }

    return images.length > 0
      ? images.map(image => ({
          url: image.url,
          alt: image.alt || title,
          sizes: '640px',
        }))
      : [fallbackImage]
  }, [fallbackImageSrc, images, title])

  return (
    <CardImageContainer aspectRatio={aspectRatio} className={className}>
      {disableSlider ? (
        <LoadingImage
          src={formattedImages[0]?.url}
          alt={formattedImages[0]?.alt}
          fill
          sizes="640px"
          className="rounded-2xl object-cover"
        />
      ) : (
        <ImageSlider
          images={formattedImages}
          disableLightbox
          hideNumberIndex
          buttonSize="small"
          reduceTransitions={reduceTransitions}
        />
      )}
    </CardImageContainer>
  )
}
